import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { IconButton, Stack, Typography } from "@mui/material";
import { useDRPContext } from "../../context";
import { useDRDPMonthYear } from "./logics";
import type { IYearRange } from "./types";

interface IDRDPMonthYear {
  index: keyof IYearRange;
}

export const DRDPMonthYear = ({ index }: IDRDPMonthYear) => {
  const { timeZone } = useDRPContext();
  const { monthYear, onPrevious, onNext, canPrevious, canNext } = useDRDPMonthYear(index);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <IconButton size="small" disabled={!canPrevious} onClick={onPrevious}>
        <KeyboardArrowLeftRoundedIcon />
      </IconButton>
      <Typography
        variant="body1SemiBold"
        sx={{
          textTransform: "capitalize",
        }}
      >
        {monthYear.toLocaleString("fr-FR", {
          month: "long",
          year: "numeric",
          timeZone,
        })}
      </Typography>
      <IconButton size="small" disabled={!canNext} onClick={onNext}>
        <KeyboardArrowRightRoundedIcon />
      </IconButton>
    </Stack>
  );
};
